import { AccessChangeTypeTag } from './AccessChangeTypeTag';
import { AppDisplay } from '@ui/applications/AppDisplay';
import classNames from 'classnames';
import { ComplianceCategories } from '@ui/icons/ComplianceCategories';
import { DataSensitivityLevelTag } from '@ui/tags/DataSensitivityLevelTag';
import { getTimeRecordDate } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarText } from '@ui/text/SonarText';
import { When } from 'react-if';
import { Button, Space, Tooltip } from 'antd';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
export const typeColumn = {
    dataIndex: 'monitorType',
    key: 'monitorType',
    render: (type) => React.createElement(AccessChangeTypeTag, { changeType: type }),
    title: COPY_SPECIFIC.TYPE,
    width: 100
};
export const appColumn = {
    dataIndex: 'applicationId',
    key: 'applicationId',
    render: (applicationId, record) => React.createElement(AppDisplay, { appId: applicationId, appLabel: record.applicationLabel, appName: record.applicationName }),
    title: COPY_SPECIFIC.APPLICATION,
    width: 170
};
export const titleColumn = {
    dataIndex: 'message',
    key: 'message',
    render: (_, { complianceCategory, dataSensitivityLevelId, hidden, message }) => React.createElement("div", { className: classNames('message', { hidden }) },
        React.createElement(Tooltip, { mouseEnterDelay: 0.5, title: message },
            React.createElement(SonarText, null, message)),
        React.createElement("div", { className: 'message-tags' },
            React.createElement(When, { condition: complianceCategory },
                React.createElement(ComplianceCategories, { categoryFlags: complianceCategory, direction: 'horizontal' })),
            React.createElement(When, { condition: dataSensitivityLevelId },
                React.createElement(DataSensitivityLevelTag, { dataSensitivityLevelId: dataSensitivityLevelId })),
            React.createElement(When, { condition: hidden },
                React.createElement("div", { className: 'hidden-text' }, COPY_SPECIFIC.HIDDEN)))),
    title: COPY_SPECIFIC.TITLE
};
export const dateColumn = {
    align: 'right',
    dataIndex: 'detectedDate',
    key: 'detectedDate',
    render: (date) => React.createElement(SonarText, null, getTimeRecordDate(date)),
    sorter: true,
    title: COPY_SPECIFIC.DETECTED_DATE,
    width: 140
};
export const actionColumn = (setHidden, navigate, isReadOnly, appSelected) => ({
    dataIndex: 'hidden',
    key: 'hidden',
    render: (hidden, { id, applicationId }) => (hidden ?
        React.createElement(Button, { onClick: setHidden.bind(null, id, false) }, COPY_SPECIFIC.RESTORE) :
        React.createElement(Space, { size: 8 },
            React.createElement(When, { condition: !appSelected },
                React.createElement(Button, { onClick: () => navigate(`${FULL_ROUTES.DATA_SECURITY}/${applicationId}`), type: 'primary' }, COPY_SPECIFIC.REVIEW)),
            React.createElement(When, { condition: !isReadOnly },
                React.createElement(Button, { onClick: setHidden.bind(null, id, true) }, COPY_SPECIFIC.HIDE)))),
    title: COPY_SPECIFIC.ACTION,
    width: appSelected || isReadOnly ? 100 : 200
});
export function getColumns(appSelected, isReadOnly, navigate, setHidden) {
    return [
        typeColumn,
        appColumn,
        titleColumn,
        dateColumn,
        ...isReadOnly && appSelected ? [] : [actionColumn(setHidden, navigate, isReadOnly, appSelected)]
    ];
}
